import moment from "moment";
export const formatDateTime = (datetime = "", format = "DD MMMM, hh:mm A") => {
  return moment(datetime).format(format);
};
